import React from 'react';
import { SearchNotFoundWrap, SearchNotFoundIcon, SearchNotFoundTitle, SearchNotFoundDesc } from './style';
// icons
import { Icon } from '../../Components/Icons/Icons';

const SearchNotFound = () => {
    return (
        <SearchNotFoundWrap>
            <SearchNotFoundIcon>
                <Icon.Box size={'32x32'}>
                    <Icon.SearchNotFound />
                </Icon.Box>
            </SearchNotFoundIcon>
            <SearchNotFoundTitle>No results found</SearchNotFoundTitle>
            <SearchNotFoundDesc>Check your spelling or try searching for something else</SearchNotFoundDesc>
        </SearchNotFoundWrap>
    );
};

export default SearchNotFound;



// WEBPACK FOOTER //
// ./src/UI/Containers/Search/SearchNotFound.js